"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _reactShare = require("react-share");

var _ref = _react.default.createElement(_reactShare.TwitterIcon, {
  round: true,
  size: 32
});

var _ref2 = _react.default.createElement(_reactShare.FacebookIcon, {
  round: true,
  size: 32
});

var _ref3 = _react.default.createElement(_reactShare.RedditIcon, {
  round: true,
  size: 32
});

var _ref4 = _react.default.createElement(_reactShare.EmailIcon, {
  round: true,
  size: 32
});

var ShareButtons = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(ShareButtons, _React$Component);

  function ShareButtons() {
    (0, _classCallCheck2.default)(this, ShareButtons);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ShareButtons).apply(this, arguments));
  }

  (0, _createClass2.default)(ShareButtons, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          style = _this$props.style;
      var _this$props2 = this.props,
          title = _this$props2.title,
          url = _this$props2.url;
      return _react.default.createElement("section", {
        className: (0, _classnames.default)('share-buttons', className),
        style: style
      }, _react.default.createElement("div", {
        className: "share-button-group"
      }, _react.default.createElement(_reactShare.TwitterShareButton, {
        className: "share-button",
        url: url,
        title: title
      }, _ref)), _react.default.createElement("div", {
        className: "share-button-group"
      }, _react.default.createElement(_reactShare.FacebookShareButton, {
        className: "share-button",
        url: url,
        quote: title
      }, _ref2)), _react.default.createElement("div", {
        className: "share-button-group"
      }, _react.default.createElement(_reactShare.RedditShareButton, {
        className: "share-button",
        url: url,
        quote: title
      }, _ref3)), _react.default.createElement("div", {
        className: "share-button-group"
      }, _react.default.createElement(_reactShare.EmailShareButton, {
        body: title,
        className: "share-button",
        subject: title,
        url: url
      }, _ref4)));
    }
  }]);
  return ShareButtons;
}(_react.default.Component);

ShareButtons.defaultProps = {
  title: 'Calico',
  url: 'http://calicolabs.com'
};
var _default = ShareButtons;
exports.default = _default;